import CloneContentModal from 'ContentEditorUI/components/modals/contentManagement/CloneContentModal';
import DeleteContentModal from 'ContentEditorUI/components/modals/contentManagement/DeleteContentModal';
import useContentModalActions from 'ContentEditorUI/hooks/useContentModalActions';
// @ts-ignore Untyped module
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentActionsModalContainer = ({
  content,
  openModalName,
  closeModal,
  modalOptions,
  updateExcludedContentIdsFilter
}) => {
  const {
    cloneContent,
    deleteContent
  } = useContentModalActions(closeModal, updateExcludedContentIdsFilter);
  if (!content || !openModalName) {
    return null;
  }
  const sharedModalProps = {
    closeModal,
    content
  };
  if (openModalName === 'CLONE') {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      _jsx(CloneContentModal, Object.assign({}, sharedModalProps, {
        cloneContent: cloneContent
      }))
    );
  } else if (openModalName === 'DELETE') {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      _jsx(DeleteContentModal, Object.assign({}, sharedModalProps, {
        deleteContent: deleteContent
      }))
    );
  } else if (openModalName === 'SHARE') {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        SocialComposerPanel
      }) => /*#__PURE__*/_jsx(SocialComposerPanel, Object.assign({}, modalOptions, {
        // note this client tag should eventually be updated to "content-management-editor"
        clientTag: "content-management-ui",
        open: true,
        onCloseModal: closeModal
      }))
    });
  }
  return null;
};
export default ContentActionsModalContainer;